import { IPrefecture } from '../models/prefecture';

const fixedDataPrefectures: Array<IPrefecture> = [
  {
    code: 'hokkaido',
    name_en: 'Hokkaido',
    name_ja: '北海道',
    name_zh_cn: '北海道',
    name_zh_hk: '北海道',
    name_zh_tw: '北海道',
  },
  {
    code: 'aomori',
    name_en: 'Aomori',
    name_ja: '青森県',
    name_zh_cn: '青森县',
    name_zh_hk: '青森縣',
    name_zh_tw: '青森縣',
  },
  {
    code: 'iwate',
    name_en: 'Iwate',
    name_ja: '岩手県',
    name_zh_cn: '岩手县',
    name_zh_hk: '岩手縣',
    name_zh_tw: '岩手縣',
  },
  {
    code: 'miyagi',
    name_en: 'Miyagi',
    name_ja: '宮城県',
    name_zh_cn: '宫城县',
    name_zh_hk: '宮城縣',
    name_zh_tw: '宮城縣',
  },
  {
    code: 'akita',
    name_en: 'Akita',
    name_ja: '秋田県',
    name_zh_cn: '秋田县',
    name_zh_hk: '秋田縣',
    name_zh_tw: '秋田縣',
  },
  {
    code: 'yamagata',
    name_en: 'Yamagata',
    name_ja: '山形県',
    name_zh_cn: '山形县',
    name_zh_hk: '山形縣',
    name_zh_tw: '山形縣',
  },
  {
    code: 'fukushima',
    name_en: 'Fukushima',
    name_ja: '福島県',
    name_zh_cn: '福岛县',
    name_zh_hk: '福島縣',
    name_zh_tw: '福島縣',
  },
  {
    code: 'ibaraki',
    name_en: 'Ibaraki',
    name_ja: '茨城県',
    name_zh_cn: '茨城县',
    name_zh_hk: '茨城縣',
    name_zh_tw: '茨城縣',
  },
  {
    code: 'tochigi',
    name_en: 'Tochigi',
    name_ja: '栃木県',
    name_zh_cn: '栃木县',
    name_zh_hk: '栃木縣',
    name_zh_tw: '栃木縣',
  },
  {
    code: 'gunma',
    name_en: 'Gunma',
    name_ja: '群馬県',
    name_zh_cn: '群马县',
    name_zh_hk: '群馬縣',
    name_zh_tw: '群馬縣',
  },
  {
    code: 'saitama',
    name_en: 'Saitama',
    name_ja: '埼玉県',
    name_zh_cn: '埼玉县',
    name_zh_hk: '埼玉縣',
    name_zh_tw: '埼玉縣',
  },
  {
    code: 'chiba',
    name_en: 'Chiba',
    name_ja: '千葉県',
    name_zh_cn: '千叶县',
    name_zh_hk: '千葉縣',
    name_zh_tw: '千葉縣',
  },
  {
    code: 'tokyo',
    name_en: 'Tokyo',
    name_ja: '東京都',
    name_zh_cn: '东京都',
    name_zh_hk: '東京都',
    name_zh_tw: '東京都',
  },
  {
    code: 'kanagawa',
    name_en: 'Kanagawa',
    name_ja: '神奈川県',
    name_zh_cn: '神奈川县',
    name_zh_hk: '神奈川縣',
    name_zh_tw: '神奈川縣',
  },
  {
    code: 'niigata',
    name_en: 'Niigata',
    name_ja: '新潟県',
    name_zh_cn: '新泻县',
    name_zh_hk: '新潟縣',
    name_zh_tw: '新潟縣',
  },
  {
    code: 'toyama',
    name_en: 'Toyama',
    name_ja: '富山県',
    name_zh_cn: '富山县',
    name_zh_hk: '富山縣',
    name_zh_tw: '富山縣',
  },
  {
    code: 'ishikawa',
    name_en: 'Ishikawa',
    name_ja: '石川県',
    name_zh_cn: '石川县',
    name_zh_hk: '石川縣',
    name_zh_tw: '石川縣',
  },
  {
    code: 'fukui',
    name_en: 'Fukui',
    name_ja: '福井県',
    name_zh_cn: '福井县',
    name_zh_hk: '福井縣',
    name_zh_tw: '福井縣',
  },
  {
    code: 'yamanashi',
    name_en: 'Yamanashi',
    name_ja: '山梨県',
    name_zh_cn: '山梨县',
    name_zh_hk: '山梨縣',
    name_zh_tw: '山梨縣',
  },
  {
    code: 'nagano',
    name_en: 'Nagano',
    name_ja: '長野県',
    name_zh_cn: '长野县',
    name_zh_hk: '長野縣',
    name_zh_tw: '長野縣',
  },
  {
    code: 'gifu',
    name_en: 'Gifu',
    name_ja: '岐阜県',
    name_zh_cn: '岐阜县',
    name_zh_hk: '岐阜縣',
    name_zh_tw: '岐阜縣',
  },
  {
    code: 'shizuoka',
    name_en: 'Shizuoka',
    name_ja: '静岡県',
    name_zh_cn: '静冈县',
    name_zh_hk: '靜岡縣',
    name_zh_tw: '靜岡縣',
  },
  {
    code: 'aichi',
    name_en: 'Aichi',
    name_ja: '愛知県',
    name_zh_cn: '爱知县',
    name_zh_hk: '愛知縣',
    name_zh_tw: '愛知縣',
  },
  {
    code: 'mie',
    name_en: 'Mie',
    name_ja: '三重県',
    name_zh_cn: '三重县',
    name_zh_hk: '三重縣',
    name_zh_tw: '三重縣',
  },
  {
    code: 'shiga',
    name_en: 'Shiga',
    name_ja: '滋賀県',
    name_zh_cn: '滋贺县',
    name_zh_hk: '滋賀縣',
    name_zh_tw: '滋賀縣',
  },
  {
    code: 'kyoto',
    name_en: 'Kyoto',
    name_ja: '京都府',
    name_zh_cn: '京都府',
    name_zh_hk: '京都府',
    name_zh_tw: '京都府',
  },
  {
    code: 'osaka',
    name_en: 'Osaka',
    name_ja: '大阪府',
    name_zh_cn: '大阪府',
    name_zh_hk: '大阪府',
    name_zh_tw: '大阪府',
  },
  {
    code: 'hyogo',
    name_en: 'Hyogo',
    name_ja: '兵庫県',
    name_zh_cn: '兵库县',
    name_zh_hk: '兵庫縣',
    name_zh_tw: '兵庫縣',
  },
  {
    code: 'nara',
    name_en: 'Nara',
    name_ja: '奈良県',
    name_zh_cn: '奈良县',
    name_zh_hk: '奈良縣',
    name_zh_tw: '奈良縣',
  },
  {
    code: 'wakayama',
    name_en: 'Wakayama',
    name_ja: '和歌山県',
    name_zh_cn: '和歌山县',
    name_zh_hk: '和歌山縣',
    name_zh_tw: '和歌山縣',
  },
  {
    code: 'tottori',
    name_en: 'Tottori',
    name_ja: '鳥取県',
    name_zh_cn: '鸟取县',
    name_zh_hk: '鳥取縣',
    name_zh_tw: '鳥取縣',
  },
  {
    code: 'shimane',
    name_en: 'Shimane',
    name_ja: '島根県',
    name_zh_cn: '岛根县',
    name_zh_hk: '島根縣',
    name_zh_tw: '島根縣',
  },
  {
    code: 'okayama',
    name_en: 'Okayama',
    name_ja: '岡山県',
    name_zh_cn: '冈山县',
    name_zh_hk: '岡山縣',
    name_zh_tw: '岡山縣',
  },
  {
    code: 'hiroshima',
    name_en: 'Hiroshima',
    name_ja: '広島県',
    name_zh_cn: '广岛县',
    name_zh_hk: '廣島縣',
    name_zh_tw: '廣島縣',
  },
  {
    code: 'yamaguchi',
    name_en: 'Yamaguchi',
    name_ja: '山口県',
    name_zh_cn: '山口县',
    name_zh_hk: '山口縣',
    name_zh_tw: '山口縣',
  },
  {
    code: 'tokushima',
    name_en: 'Tokushima',
    name_ja: '徳島県',
    name_zh_cn: '德岛县',
    name_zh_hk: '德島縣',
    name_zh_tw: '德島縣',
  },
  {
    code: 'kagawa',
    name_en: 'Kagawa',
    name_ja: '香川県',
    name_zh_cn: '香川县',
    name_zh_hk: '香川縣',
    name_zh_tw: '香川縣',
  },
  {
    code: 'ehime',
    name_en: 'Ehime',
    name_ja: '愛媛県',
    name_zh_cn: '爱媛县',
    name_zh_hk: '愛媛縣',
    name_zh_tw: '愛媛縣',
  },
  {
    code: 'kochi',
    name_en: 'Kochi',
    name_ja: '高知県',
    name_zh_cn: '高知县',
    name_zh_hk: '高知縣',
    name_zh_tw: '高知縣',
  },
  {
    code: 'fukuoka',
    name_en: 'Fukuoka',
    name_ja: '福岡県',
    name_zh_cn: '福冈县',
    name_zh_hk: '福岡縣',
    name_zh_tw: '福岡縣',
  },
  {
    code: 'saga',
    name_en: 'Saga',
    name_ja: '佐賀県',
    name_zh_cn: '佐贺县',
    name_zh_hk: '佐賀縣',
    name_zh_tw: '佐賀縣',
  },
  {
    code: 'nagasaki',
    name_en: 'Nagasaki',
    name_ja: '長崎県',
    name_zh_cn: '长崎県',
    name_zh_hk: '長崎縣',
    name_zh_tw: '長崎縣',
  },
  {
    code: 'kumamoto',
    name_en: 'Kumamoto',
    name_ja: '熊本県',
    name_zh_cn: '熊本县',
    name_zh_hk: '熊本縣',
    name_zh_tw: '熊本縣',
  },
  {
    code: 'oita',
    name_en: 'Oita',
    name_ja: '大分県',
    name_zh_cn: '大分县',
    name_zh_hk: '大分縣',
    name_zh_tw: '大分縣',
  },
  {
    code: 'miyazaki',
    name_en: 'Miyazaki',
    name_ja: '宮崎県',
    name_zh_cn: '宫崎县',
    name_zh_hk: '宮崎縣',
    name_zh_tw: '宮崎縣',
  },
  {
    code: 'kagoshima',
    name_en: 'Kagoshima',
    name_ja: '鹿児島県',
    name_zh_cn: '鹿儿岛县',
    name_zh_hk: '鹿兒島縣',
    name_zh_tw: '鹿兒島縣',
  },
  {
    code: 'okinawa',
    name_en: 'Okinawa',
    name_ja: '沖縄県',
    name_zh_cn: '冲绳县',
    name_zh_hk: '沖繩縣',
    name_zh_tw: '沖繩縣',
  },
];

export default fixedDataPrefectures;
